import { PhoneCall, FileSearch, Hammer, KeyRound } from "lucide-react";

const steps = [
  {
    num: "01",
    icon: PhoneCall,
    title: "Prise de contact",
    desc: "Vous nous contactez par téléphone, email ou via notre formulaire. Réponse sous 24h.",
  },
  {
    num: "02",
    icon: FileSearch,
    title: "Diagnostic & chiffrage",
    desc: "Évaluation précise des dommages par nos experts et proposition de devis transparent.",
  },
  {
    num: "03",
    icon: Hammer,
    title: "Intervention technique",
    desc: "Nos techniciens DSP interviennent en atelier fixe ou mobile selon le sinistre.",
  },
  {
    num: "04",
    icon: KeyRound,
    title: "Restitution",
    desc: "Contrôle qualité et remise du véhicule, garantie à vie sur nos réparations DSP.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/33749906/pexels-photo-33749906.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/95 to-[#050505]" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-6">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              — Processus
            </div>
            <h2
              data-testid="process-title"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter max-w-3xl"
            >
              Un parcours<br />
              <span className="text-white/40">sans friction</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md">
            De la prise de contact à la restitution, nous simplifions chaque
            étape de votre réparation automobile.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className="relative bg-[#0A0A0A] p-8 lg:p-10 min-h-[320px] flex flex-col group hover:bg-[#111111] transition-colors"
            >
              <div className="flex items-center justify-between mb-10">
                <div className="font-heading text-5xl font-black text-[#007AFF]/30 group-hover:text-[#007AFF] transition-colors">
                  {s.num}
                </div>
                <s.icon
                  className="w-8 h-8 text-white/40 group-hover:text-white transition-colors"
                  strokeWidth={1.25}
                />
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>

              {/* Connector arrow (hidden on last) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-[#007AFF] z-10" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
